module.exports = __webpack_public_path__ + "img/stars.f3460fb0.png";